/* © 2026 FRONT OFFICE合同会社 (Front Office G.K.), Tokyo. All rights reserved. Not licensed for reuse. */
/* ==========================================================================
   The Rail — home. design_handoff_front_office_2/08-the-rail.md

   Ported from the-rail-prototype.html, behaviour unchanged:
   - hover (desktop) or the centred garment (phone) names it; click goes to the page
   - the caption never moves on the phone; only the red line does, drawn at rest
   - transforms only while the rail is moving; nothing on the main thread
   - the window past the end of the rail follows Tokyo's clock and weather

   Reads one JSON block written by sections/the-rail.liquid. Nothing here
   knows a garment by name: order, images and states all come from the blocks
   Ken arranges in the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-rail]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('[data-rail-config]').textContent);
  var RANGE = CFG.garments;
  if (!RANGE.length) return;

  /* Geometry of the drawings shipped as theme assets: drawing units, where a
     unit is about 0.3 cm hook-tip to hem. The generator wrote these when the
     drawings were made; picked images fall back to length_cm × 3.3. */
  var KNOWN = CFG.known || {};
  var UNIT_PER_CM = 3.3;
  var NOM = { longcoat: [200, 352], jacket: [240, 230], shirt: [230, 240], knit: [230, 220], tee: [230, 224], tank: [150, 190], dress: [190, 300], trouser: [170, 330], sock: [70, 90], smalls: [110, 90] };
  var HANGER = CFG.hangers; /* {coat:{src,w,h,pad}, bar:{...}} */

  function el(n, a) { var e = document.createElementNS('http://www.w3.org/2000/svg', n); for (var k in a) e.setAttribute(k, a[k]); return e; }

  var scroller = root.querySelector('[data-rail-scroll]'),
      svg = root.querySelector('[data-rail-svg]'),
      rack = root.querySelector('[data-rail-rack]'),
      cap = root.querySelector('[data-rail-cap]'),
      padL = root.querySelector('[data-rail-pad]'),
      bay = root.querySelector('[data-rail-bay]'),
      bayfloor = root.querySelector('[data-rail-bayfloor]'),
      win = root.querySelector('[data-rail-window]'),
      paneEl = root.querySelector('[data-rail-pane]'),
      capwrapEl = root.querySelector('[data-rail-capwrap]'),
      leadV = root.querySelector('[data-rail-lead]'),
      leadH = root.querySelector('[data-rail-leadh]'),
      moreEl = root.querySelector('[data-rail-more]');
  var hasWindow = !!(bay && win && paneEl && CFG.street);

  var isTouch = window.matchMedia('(hover:none)').matches || window.innerWidth < 768;
  var RAIL_Y = 20, X0 = 46, items = [], x = X0, BOUNDS = [];

  /* ---------- geometry per garment ---------- */
  var BAGGED_KNOWN = CFG.baggedKnown || {};
  function geom(d) {
    var k = KNOWN[d.code];
    /* a shipped bagged drawing carries its own geometry (rail-bagged-known) */
    if (d.bagged && d.drawing && !d.drawing.picked && BAGGED_KNOWN[d.code]) { var bk = BAGGED_KNOWN[d.code]; return { w: bk.w, h: bk.h, hook: bk.hook, pad: bk.pad }; }
    if (d.drawing && d.drawing.picked && d.drawing.w && d.drawing.h) {
      var h = Math.round((d.length_cm || 100) * UNIT_PER_CM);
      var bar = isBar(d);
      return { w: Math.round(h * d.drawing.w / d.drawing.h), h: h, hook: bar ? 30 : 35, pad: bar ? 8 : 6 };
    }
    if (k && d.drawing) return { w: k.w, h: k.h, hook: k.hook, pad: k.pad };
    return null;
  }
  function isBar(d) { return d.kind === 'trouser' || d.kind === 'sock' || d.kind === 'smalls'; }

  /* ---------- build the rail ---------- */
  RANGE.forEach(function (item, i) {
    var G = geom(item);
    var o = G ? { w: G.w, h: G.h } : { w: (NOM[item.kind] || NOM.shirt)[0], h: 0 };
    var gpad = G ? G.pad : 0;
    var bar = isBar(item);
    var HG = bar ? HANGER.bar : HANGER.coat;
    var hw = HG ? Math.round(o.w * (bar ? 0.74 : 0.66)) : 0, hh = HG ? Math.round(hw * HG.h / HG.w) : 0;
    var seat = bar ? 0.87 : 0.80;
    var hang = G ? RAIL_Y - Math.round((G.hook - G.pad) * 0.30) - G.pad : (HG ? RAIL_Y - 7 + Math.round(hh * seat) : RAIL_Y + 30);
    if (i > 0) {
      var prev = RANGE[i - 1], pg = geom(prev);
      var newCat = prev.group !== item.group;
      var prevW = pg ? pg.w : (NOM[prev.kind] || NOM.shirt)[0];
      var lap = [0.72, 0.78, 0.69, 0.82, 0.75, 0.71][i % 6];
      var pitch = Math.max(52, Math.round(prevW * lap));
      if (newCat) { var prevRight = x + prevW; BOUNDS.push({ x: prevRight + 46 }); x = prevRight + 92; }
      else x += pitch;
    }
    /* A garment with a page is a real link — crawlers, a keyboard, a
       cmd-click all get the page — with the drawing's <g> inside it. One
       without a page is a plain list item. */
    var label = item.code + ' ' + item.name;
    var wrap = item.url ? el('a', { 'href': item.url, 'class': 'g-link', 'role': 'listitem', 'aria-label': label }) : null;
    var g = el('g', { 'class': 'g dev', 'transform': 'translate(' + x + ',' + hang + ') rotate(' + (item.lean || 0) + ' ' + (o.w / 2) + ' 0)' });
    if (!wrap) { g.setAttribute('role', 'listitem'); g.setAttribute('tabindex', '0'); g.setAttribute('aria-label', label); }
    var sw = el('g', { 'class': 'sw' }); g.appendChild(sw);
    var hx = o.w / 2;
    if (G) {
      sw.appendChild(el('image', { 'class': 'flat drawn', href: item.drawing.src, x: 0, y: 0, width: G.w, height: G.h }));
      if (item.filled) sw.appendChild(el('image', { 'class': 'flat solid', href: item.filled.src, x: 0, y: 0, width: G.w, height: G.h }));
    } else if (HG) {
      sw.appendChild(el('image', { 'class': 'hanger', href: HG.src, x: hx - hw / 2, y: -Math.round(hh * seat), width: hw, height: hh, preserveAspectRatio: 'xMidYMax meet' }));
    } else {
      g.appendChild(el('path', { 'class': 'hook', d: 'M ' + hx + ' 4 L ' + hx + ' ' + (RAIL_Y - hang + 2) + ' M ' + (hx - 13) + ' 4 L ' + hx + ' -6 L ' + (hx + 13) + ' 4' }));
    }
    /* The locked page (Ken, 22 Sep 2026 — the-rail.liquid, bagged mode).
       A garment that has its own bagged drawing (item.bagged: the garment
       drawn inside its cover, one generated image per garment) shows that in
       place of the line drawing — handled above, where geom() reads it. A
       garment with only a line drawing gets the shared cover laid over it,
       stretched to the garment, inside .sw so it sways with the garment.
       An empty hanger stays an empty hanger: no bag (Ken's call). */
    /* The cover ends exactly at the garment's hem, so the rail's height, the
       floor and the hem the red line reaches are the home page's, unchanged
       (Ken, 22 Sep: the line "was perfect" — a longer cover had moved it). */
    if (CFG.bagged && CFG.bags && G && !item.bagged) {
      var bagTop = RAIL_Y + 8 - hang, bagBot = G.h - gpad;
      var bagW = bar ? Math.round(Math.max(o.w, hw) * 1.06) : Math.round(o.w * 1.10);
      sw.appendChild(el('image', { 'class': 'bag', href: bar ? CFG.bags.trouser : CFG.bags.coat, x: Math.round(hx - bagW / 2), y: bagTop, width: bagW, height: bagBot - bagTop, preserveAspectRatio: 'none' }));
    }
    if (wrap) { wrap.appendChild(g); svg.appendChild(wrap); } else svg.appendChild(g);
    items.push({ el: g, focusEl: wrap || g, cx: x + o.w / 2, data: item, bottom: hang + o.h - gpad, x: x, y: hang, w: o.w, h: (G ? o.h - gpad : o.h), img: G ? item.drawing.src : null });
  });

  var railEnd = Math.max.apply(null, items.map(function (t) { return t.x + t.w; })) + X0 + 26;
  var VH = Math.max(430, Math.max.apply(null, items.map(function (t) { return t.bottom; })) + 96);
  svg.setAttribute('viewBox', '0 0 ' + railEnd + ' ' + VH);

  /* The phone's viewport height changes every time the browser's toolbar
     collapses or expands during a scroll, and the rail was re-fitting itself
     to each change — Ken, 22 Sep 2026: "the size of the rail changes when you
     scroll up and down." So the height is measured once and re-measured only
     when the WIDTH changes (a rotation), never on a toolbar collapse. */
  var fitW = window.innerWidth, fitH = window.innerHeight;
  function fitRack() {
    if (window.innerWidth !== fitW) { fitW = window.innerWidth; fitH = window.innerHeight; }
    if (window.innerWidth < 768) {
      var h = Math.round(Math.min(fitH * 0.56, 620));
      var MW = Math.round(h * railEnd / VH);
      rack.style.minWidth = MW + 'px'; rack.style.width = MW + 'px'; rack.style.height = h + 'px';
      padL.style.flexBasis = Math.max(0, Math.round(window.innerWidth / 2 - items[0].cx / railEnd * MW)) + 'px';
    } else { rack.style.height = ''; rack.style.width = ''; rack.style.minWidth = ''; padL.style.flexBasis = ''; }
    requestAnimationFrame(function () {
      var h = rack.getBoundingClientRect().height;
      if (hasWindow) { bay.style.height = h + 'px'; bayfloor.style.top = Math.round(h * (VH - 12) / VH) + 'px'; }
      placeDetents();
    });
  }
  window.addEventListener('resize', fitRack);
  rack.style.setProperty('--ar', railEnd + ' / ' + VH);
  fitRack();

  /* the steel: bar, uprights on the category boundaries, feet, floor */
  var deco = el('g', {}), T = 4, FLOOR = VH - 12, BASE = FLOOR - T;
  function steel(x, y, w, h) { return el('rect', { 'class': 'steel', x: x, y: y, width: w, height: h }); }
  var barLayer = el('g', { 'class': 'barlayer' }); barLayer.appendChild(steel(18, RAIL_Y - T / 2, railEnd - 36, T));
  [26, railEnd - 26].concat(BOUNDS.map(function (b) { return b.x; })).forEach(function (ux) { deco.appendChild(steel(ux - T / 2, RAIL_Y - T / 2, T, BASE - (RAIL_Y - T / 2))); });
  [26, railEnd - 26].forEach(function (ux) { deco.appendChild(steel(ux - 28, BASE, 56, T)); });
  BOUNDS.forEach(function (b) { deco.appendChild(steel(b.x - 18, BASE, 36, T)); });
  deco.appendChild(el('path', { 'class': 'floor', d: 'M 0 ' + FLOOR + ' L ' + railEnd + ' ' + FLOOR }));
  svg.insertBefore(deco, svg.firstChild);
  svg.appendChild(barLayer);

  /* ---------- state ---------- */
  function released(d) { return !!d.released; }
  function stateText(d) {
    if (released(d)) return { cls: '', txt: CFG.t.released + (d.price ? ' · ' + d.price : '') };
    return { cls: 'dev', txt: CFG.t.in_development + (d.price ? ' · ' + d.price : '') };
  }
  items.forEach(function (it) {
    it.el.classList.toggle('dev', !released(it.data));
    it.el.classList.toggle('nophoto', !it.data.filled); /* released but not yet photographed: the drawing stays */
  });

  /* ---------- the name and the line ---------- */
  var LEADKEY = null, SEL = -1;
  function leadTo(gx, hemY, key) {
    var host = capwrapEl.getBoundingClientRect();
    var capW = Math.min(17 * 16, host.width - 16);
    var moreW = (moreEl.offsetWidth || 0) + 24;
    var cx = isTouch ? 0 : Math.min(Math.max(gx, 8), Math.max(host.width - capW - 8 - moreW, 8));
    if (!isTouch) cap.style.marginLeft = cx + 'px';
    var up = Math.max(0, host.top - hemY - 6), W = Math.abs(gx - cx), L = Math.min(cx, gx);
    var changed = key !== LEADKEY; LEADKEY = key;
    var vT = 'translate3d(' + gx + 'px,-400px,0) scaleY(' + (up / 400) + ')';
    var hT = 'translate3d(' + L + 'px,0,0) scaleX(' + (W / 1000) + ')';
    if (gx < cx) { leadH.style.transformOrigin = '100% 50%'; hT = 'translate3d(' + (cx - 1000) + 'px,0,0) scaleX(' + (W / 1000) + ')'; } else { leadH.style.transformOrigin = '0% 50%'; }
    if (changed) {
      leadV.classList.add('still'); leadH.classList.add('still');
      leadV.style.transform = 'translate3d(' + gx + 'px,-400px,0) scaleY(0)';
      leadH.style.transform = (gx < cx ? 'translate3d(' + (cx - 1000) + 'px,0,0)' : 'translate3d(' + L + 'px,0,0)') + ' scaleX(0)';
      void leadV.offsetWidth;
      leadV.classList.remove('still'); leadH.classList.remove('still');
      requestAnimationFrame(function () { leadH.style.transform = hT; leadV.style.transform = vT; });
    } else {
      leadV.classList.add('still'); leadH.classList.add('still');
      leadV.style.transform = vT; leadH.style.transform = hT;
      requestAnimationFrame(function () { leadV.classList.remove('still'); leadH.classList.remove('still'); });
    }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function writeCaption(d) {
    var st = stateText(d);
    cap.innerHTML = '<div class="num caps">' + esc(d.code.replace('-', ' ')) + '</div><div class="nm">' + esc(d.name) + '</div><div class="st ' + st.cls + '">' + esc(st.txt) + '</div>';
    if (d.url) { moreEl.href = d.url; moreEl.hidden = false; moreEl.setAttribute('aria-label', CFG.t.more + ' · ' + d.name); }
    else { moreEl.hidden = true; moreEl.removeAttribute('href'); }
  }
  function paint(i) {
    var it = items[i], d = it.data;
    if (SEL !== i) {
      writeCaption(d);
      if (isTouch && SEL >= 0) tick();
      items.forEach(function (o, j) { o.el.classList.toggle('on', j === i); });
      SEL = i;
    }
    var box = svg.getBoundingClientRect(), host = capwrapEl.getBoundingClientRect();
    var gx = box.left + (it.cx / railEnd) * box.width - host.left;
    var hemY = box.top + ((it.y + (it.h || 60)) / (svg.viewBox.baseVal.height || 1)) * box.height;
    leadTo(gx, hemY, d.code);
  }
  function paintText(i) {
    writeCaption(items[i].data);
    if (SEL >= 0) tick(); SEL = i;
    items.forEach(function (o, j) { o.el.classList.toggle('on', j === i); });
  }

  function touch(i, cls) {
    var e = items[i].el; if (e.classList.contains('touch')) return;
    e.classList.remove('touch', 'brush', 'roll'); void e.getBoundingClientRect();
    e.classList.add(cls);
    var end = function () { e.classList.remove('touch', 'brush', 'roll'); e.removeEventListener('animationend', end); };
    e.addEventListener('animationend', end);
  }

  /* alpha maps: the pointer hits cloth, not the transparent box around it */
  var ALPHA = {}, AS = 4;
  items.forEach(function (it, i) {
    if (!it.img) return;
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      var cw = Math.max(1, Math.round(it.w / AS)), ch = Math.max(1, Math.round(it.h / AS));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, cw, ch);
      try { ALPHA[i] = { d: ctx.getImageData(0, 0, cw, ch).data, w: cw, h: ch }; } catch (e) { /* cross-origin canvas: fall back to the box */ }
    };
    im.src = it.img;
  });
  function hitAt(clientX, clientY) {
    var pt = svg.createSVGPoint(); pt.x = clientX; pt.y = clientY;
    var m = svg.getScreenCTM(); if (!m) return -1;
    var p = pt.matrixTransform(m.inverse());
    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i], lx = p.x - it.x, ly = p.y - it.y;
      if (lx < 0 || ly < 0 || lx > it.w || ly > (it.h || 60)) continue;
      var A = ALPHA[i];
      if (!A) { if (!it.img && ly < 60) return i; if (it.img) return i; continue; }
      var ax = Math.min(A.w - 1, Math.floor(lx / AS)), ay = Math.min(A.h - 1, Math.floor(ly / AS));
      if (A.d[(ay * A.w + ax) * 4 + 3] > 40) return i;
    }
    return -1;
  }
  function open(i, e) {
    var u = items[i].data.url; if (!u) return;
    if (e && (e.metaKey || e.ctrlKey || e.button === 1)) { window.open(u, '_blank', 'noopener'); return; }
    window.location.href = u;
  }

  var HOV = -1;
  svg.addEventListener('mousemove', function (e) {
    if (isTouch) return;
    var i = hitAt(e.clientX, e.clientY);
    svg.style.cursor = i >= 0 && items[i].data.url ? 'pointer' : 'default';
    if (i === HOV) return;
    HOV = i;
    if (i >= 0) { paint(i); touch(i, 'touch'); if (items[i - 1]) touch(i - 1, 'brush'); if (items[i + 1]) touch(i + 1, 'brush'); }
  });
  /* The images swallow no pointer events, so the <a> never navigates by
     itself: which garment a tap opens is decided here (the centred one on a
     phone, the one under the pointer on a desktop), never by the browser. */
  svg.addEventListener('click', function (e) { e.preventDefault(); var i = isTouch ? centre() : hitAt(e.clientX, e.clientY); if (i >= 0) { if (isTouch) touch(i, 'touch'); open(i, e); } });
  svg.addEventListener('auxclick', function (e) { if (e.button !== 1 || isTouch) return; e.preventDefault(); var i = hitAt(e.clientX, e.clientY); if (i >= 0) open(i, e); });
  items.forEach(function (it, i) {
    it.focusEl.addEventListener('focus', function () { paint(i); touch(i, 'touch'); });
    /* Enter on a link is the browser's own; Space is ours so both keys open. */
    it.focusEl.addEventListener('keydown', function (e) { if (e.key === ' ' || (e.key === 'Enter' && it.focusEl === it.el)) { e.preventDefault(); open(i, e); } });
  });
  rack.addEventListener('mouseleave', function () { if (isTouch) return; HOV = -1; svg.style.cursor = 'default'; paint(centre()); });

  /* scrolling the rail moves the clothes on it — once, as it starts */
  var lastScroll = 0;
  function swayAll() {
    var now = Date.now(), idle = now - lastScroll > 450; lastScroll = now;
    if (!idle) return;
    items.forEach(function (it, i) { setTimeout(function () { touch(i, 'roll'); }, i * 18); });
  }
  scroller.addEventListener('scroll', swayAll, { passive: true });
  window.addEventListener('scroll', swayAll, { passive: true });

  function centre() {
    var box = svg.getBoundingClientRect(), mid = window.innerWidth / 2, best = 0, bd = 1e9;
    items.forEach(function (it, i) { var px = box.left + it.cx / railEnd * box.width, dd = Math.abs(px - mid); if (dd < bd) { bd = dd; best = i; } });
    return best;
  }
  function tick() { try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) { /* not on iOS */ } }
  function placeDetents() {
    var old = scroller.querySelectorAll('.rail__detent'); for (var k = 0; k < old.length; k++) old[k].remove();
    if (!isTouch) return;
    var padW = padL.getBoundingClientRect().width, rw = rack.getBoundingClientRect().width;
    items.forEach(function (it, i) { var d = document.createElement('div'); d.className = 'rail__detent' + ((i === 0 || i === items.length - 1) ? ' stop' : ''); d.style.left = Math.round(padW + it.cx / railEnd * rw) + 'px'; scroller.appendChild(d); });
    if (hasWindow) {
      var wb = win.getBoundingClientRect(), bb = bay.getBoundingClientRect();
      var d = document.createElement('div'); d.className = 'rail__detent'; d.style.left = Math.round(padW + rw + (wb.left - bb.left) + wb.width / 2) + 'px'; scroller.appendChild(d);
    }
  }

  var ticking = false, settleT = null, inBay = false;
  scroller.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      if (isTouch) { capwrapEl.classList.add('moving'); clearTimeout(settleT); settleT = setTimeout(settle, 170); }
      else if (!inBay) paint(centre());
      ticking = false;
    });
  }, { passive: true });
  function settle() {
    capwrapEl.classList.remove('moving');
    if (inBay) { paintWeather(); return; }
    SEL = -1; LEADKEY = null; paint(centre());
  }
  if ('onscrollend' in window) scroller.addEventListener('scrollend', function () { clearTimeout(settleT); settle(); });
  window.addEventListener('resize', function () { paint(centre()); });

  paint(isTouch ? 0 : Math.min(2, items.length - 1));

  /* ---------- the window: Tokyo, live ---------- */
  if (!hasWindow) return;
  var STREET = CFG.street; /* state → image url; loaded only when the bay is near */
  var WX = null, WXTXT = { 0: 'Clear', 1: 'Mostly clear', 2: 'Partly cloudy', 3: 'Overcast', 45: 'Fog', 48: 'Fog', 51: 'Light drizzle', 53: 'Drizzle', 55: 'Drizzle', 56: 'Freezing drizzle', 57: 'Freezing drizzle', 61: 'Light rain', 63: 'Rain', 65: 'Heavy rain', 66: 'Freezing rain', 67: 'Freezing rain', 71: 'Light snow', 73: 'Snow', 75: 'Heavy snow', 77: 'Snow grains', 80: 'Showers', 81: 'Showers', 82: 'Heavy showers', 85: 'Snow showers', 86: 'Snow showers', 95: 'Thunderstorm', 96: 'Thunderstorm', 99: 'Thunderstorm' };
  var armed = false, lastState = null;
  function tokyoHour() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', hour: 'numeric', minute: 'numeric', hour12: false, month: 'numeric' });
    var parts = {}; f.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { h: parseInt(parts.hour, 10) + parseInt(parts.minute, 10) / 60, m: parseInt(parts.month, 10) };
  }
  function pick(t, wx) {
    var rain = wx && ((wx.code >= 51 && wx.code <= 67) || (wx.code >= 80 && wx.code <= 82) || wx.code >= 95);
    var snow = wx && ((wx.code >= 71 && wx.code <= 77) || wx.code === 85 || wx.code === 86);
    var night = wx ? !wx.isDay : (t.h < 5.5 || t.h >= 18);
    var dusk = wx ? (Math.abs(t.h - wx.sunset) < 0.75 || Math.abs(t.h - wx.sunrise) < 0.6) : ((t.h >= 17 && t.h < 18) || (t.h >= 5.5 && t.h < 6.5));
    if (snow) return 'snow';
    if (rain) return night ? 'night-rain' : 'rain';
    if (night) return 'night';
    if (dusk) return 'dusk';
    if (t.m === 4) return 'spring';
    if (t.m === 11) return 'autumn';
    return 'day';
  }
  function show(state) {
    lastState = state; if (!armed) return;
    var src = STREET[state] || STREET.day; if (!src) return;
    paneEl.style.backgroundImage = 'url(' + src + ')';
    paneEl.className = 'rail__pane ' + state;
  }
  function run() {
    var t = tokyoHour(); show(pick(t, null));
    if (!window.fetch) return;
    fetch('https://api.open-meteo.com/v1/forecast?latitude=35.644&longitude=139.699&current=weather_code,is_day,temperature_2m&daily=sunrise,sunset&timezone=Asia%2FTokyo')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var hm = function (iso) { var s = iso.split('T')[1].split(':'); return parseInt(s[0], 10) + parseInt(s[1], 10) / 60; };
        WX = { t: Math.round(j.current.temperature_2m), c: j.current.weather_code };
        show(pick(t, { code: j.current.weather_code, isDay: j.current.is_day === 1, sunrise: hm(j.daily.sunrise[0]), sunset: hm(j.daily.sunset[0]) }));
      }).catch(function () { /* the window falls back to the clock */ });
  }
  function arm() { if (armed) return; armed = true; run(); setInterval(run, 10 * 60 * 1000); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) arm(); }); }, { root: scroller, rootMargin: '0px 100% 0px 100%' }).observe(bay);
  } else arm();

  function tokyoClock() { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date()); }
  function tokyoDate() { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', weekday: 'long', day: 'numeric', month: 'long' }).format(new Date()); }
  function paintWeather() {
    var line = WX ? (WX.t + '°C, ' + (WXTXT[WX.c] || '').toLowerCase()) : tokyoDate();
    cap.innerHTML = '<div class="num caps">' + esc(CFG.t.shibuya) + ' · ' + tokyoClock() + ' ' + esc(CFG.t.jst) + '</div><div class="nm">' + esc(line) + '</div><div class="st">' + esc(WX ? tokyoDate() : CFG.t.live) + '</div>';
    var w = win.getBoundingClientRect(), host = capwrapEl.getBoundingClientRect();
    SEL = -1; leadTo(w.left + w.width / 2 - host.left, w.bottom, 'window');
    items.forEach(function (o) { o.el.classList.remove('on'); });
  }
  function parallax() {
    var sx = scroller.scrollLeft || 0, start = rack.getBoundingClientRect().width - window.innerWidth;
    var d = Math.max(0, sx - start);
    if (!isTouch) win.style.setProperty('--px', (d * 0.12) + 'px');
    paneEl.style.setProperty('--bx', (-d * 0.08) + 'px');
  }
  scroller.addEventListener('scroll', function () {
    requestAnimationFrame(parallax);
    var w = win.getBoundingClientRect();
    var visible = w.left < window.innerWidth * 0.72;
    if (visible && !inBay) { inBay = true; capwrapEl.classList.add('bay'); if (!isTouch) paintWeather(); }
    else if (!visible && inBay) { inBay = false; capwrapEl.classList.remove('bay'); if (!isTouch) paint(centre()); }
    else if (visible && !isTouch) paintWeather();
  }, { passive: true });
  if (!isTouch) {
    document.addEventListener('mousemove', function (e) {
      var r = (e.clientX / window.innerWidth - 0.5);
      requestAnimationFrame(function () { paneEl.style.setProperty('--bx', (-r * 8) + 'px'); });
    }, { passive: true });
  }
})();
